import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { StaggerGroup, staggerItem, Reveal } from "@/components/Reveal";
import { TOPIC_LIST } from "@/data/site";
import { TOPICS } from "@/constants/testIds";

export default function Topics() {
  return (
    <section
      id="topics"
      data-testid={TOPICS.section}
      className="relative bg-white/[0.02] py-24 sm:py-28"
    >
      <div className="mx-auto max-w-6xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <p className="font-display text-xs font-semibold uppercase tracking-[0.3em] text-brand">
              What we cover
            </p>
          </Reveal>
          <Reveal delay={0.06}>
            <h2 className="mt-4 font-display text-3xl font-black leading-[1.05] tracking-tight text-white sm:text-4xl lg:text-5xl">
              Topics designed to make you tech-fluent.
            </h2>
          </Reveal>
        </div>

        <StaggerGroup className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {TOPIC_LIST.map((t) => {
            const Icon = t.icon;
            return (
              <motion.div
                key={t.slug}
                variants={staggerItem}
                data-testid={TOPICS.card(t.slug)}
                className="group relative overflow-hidden rounded-2xl border border-white/10 bg-white/[0.03] p-8 shadow-[0_2px_10px_-3px_rgba(212,175,55,0.1)] transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-2 hover:border-brand/30 hover:shadow-[0_18px_40px_-12px_rgba(212,175,55,0.28)]"
              >
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-brand/0 to-cyan-accent/0 opacity-0 transition-opacity duration-300 group-hover:from-brand/[0.04] group-hover:to-cyan-accent/[0.06] group-hover:opacity-100" />
                <div className="relative">
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-xl border border-brand/15 bg-brand/10 text-brand transition-colors duration-300 group-hover:bg-brand group-hover:text-black">
                    <Icon className="h-6 w-6" strokeWidth={1.75} />
                  </div>
                  <h3 className="mt-6 flex items-center gap-1.5 font-display text-xl font-bold tracking-tight text-white">
                    {t.title}
                    <ArrowUpRight className="h-4 w-4 -translate-y-0.5 text-neutral-400 transition-[transform,color] duration-300 group-hover:translate-x-0.5 group-hover:text-brand" />
                  </h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-neutral-400">
                    {t.desc}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </StaggerGroup>
      </div>
    </section>
  );
}
